const TRAILING_SLASHES = /\/+$/;

/** The full assistant page; `/voice` redirects here. */
export const ASSISTANT_PATH = "/assistant";

export function isAssistantPathname(pathname: string): boolean {
  return pathname.replace(TRAILING_SLASHES, "") === ASSISTANT_PATH;
}
